export default "__VITE_ASSET__CKGo3QUI__"